/**
 * 將數字轉換成會計格式（123,456.00）
 * @param value: Number
 * @returns String
 */

import numeral from 'numeral';

const formatFinanceNumber = (value: number): string => {
  const result = numeral(value).format('0,0.00');
  return result;
};

export default formatFinanceNumber;
